document.documentElement.classList.remove('no-js');

const q=(s,c=document)=>c.querySelector(s);
const qa=(s,c=document)=>[...c.querySelectorAll(s)];
const money=(cents)=>new Intl.NumberFormat(document.documentElement.lang||'fr-FR',{style:'currency',currency:(window.Shopify&&Shopify.currency&&Shopify.currency.active)||'EUR'}).format(cents/100);

function setOverlay(open){const o=q('[data-overlay]');if(o)o.classList.toggle('is-open',open)}
function togglePanel(sel,open){const el=q(sel);if(!el)return;el.classList.toggle('is-open',open);setOverlay(open);document.body.classList.toggle('drawer-open',open)}
function closeAllPanels(){['#MobileMenu','#CartDrawer','#FilterDrawer'].forEach(s=>q(s)?.classList.remove('is-open'));q('#QuickBuyDrawer')?.classList.remove('is-open');q('#QuickBuyDrawer')?.setAttribute('aria-hidden','true');setOverlay(false);document.body.classList.remove('drawer-open')}

document.addEventListener('click',e=>{
  const action=e.target.closest('[data-action]')?.dataset.action;
  if(action==='menu-open')togglePanel('#MobileMenu',true);
  if(action==='menu-close')togglePanel('#MobileMenu',false);
  if(action==='cart-open')openCart();
  if(action==='cart-close')togglePanel('#CartDrawer',false);
  if(action==='filter-open')togglePanel('#FilterDrawer',true);
  if(action==='filter-close')togglePanel('#FilterDrawer',false);
  if(action==='overlay-close')closeAllPanels();
  if(action==='quick-buy-close')closeQuickBuy();
});

document.addEventListener('keydown',e=>{if(e.key==='Escape')closeAllPanels()});

async function cartJson(){const r=await fetch('/cart.js',{headers:{Accept:'application/json'}});return r.json()}
async function changeLine(key,quantity){await fetch('/cart/change.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({id:key,quantity})});await renderCart()}

async function renderCart(){
  const cart=await cartJson(),drawer=q('#CartDrawer');if(!drawer)return;
  const count=q('[data-cart-count]');if(count)count.textContent=cart.item_count;
  const body=q('[data-cart-body]',drawer),subtotal=q('[data-cart-subtotal]',drawer),progress=q('[data-cart-progress]',drawer),msg=q('[data-cart-progress-text]',drawer);
  if(!cart.items.length){body.innerHTML='<div class="empty-state"><p>Votre sélection est vide.</p><a class="btn btn--primary" href="/collections/all">Découvrir la collection</a></div>'}
  else body.innerHTML=cart.items.map(i=>`<div class="cart-line"><a href="${i.url}">${i.image?`<img src="${i.image}&width=180" alt="">`:''}</a><div><a href="${i.url}"><strong>${i.product_title}</strong></a><div class="muted">${i.variant_title||''}</div><div>${money(i.final_line_price)}</div><div><button data-line-dec="${i.key}">−</button> ${i.quantity} <button data-line-inc="${i.key}">+</button></div></div><button aria-label="Supprimer" data-line-remove="${i.key}">×</button></div>`).join('');
  if(subtotal)subtotal.textContent=money(cart.total_price);
  const threshold=Number(drawer.dataset.freeShipping||10000),pct=Math.min(100,Math.round(cart.total_price/threshold*100));
  if(progress)progress.style.setProperty('--progress',pct+'%');
  if(msg)msg.textContent=cart.total_price>=threshold?'Livraison offerte débloquée.':`Plus que ${money(threshold-cart.total_price)} pour la livraison offerte.`;
}

document.addEventListener('click',async e=>{
  const dec=e.target.closest('[data-line-dec]'),inc=e.target.closest('[data-line-inc]'),rem=e.target.closest('[data-line-remove]');
  if(dec||inc||rem){const el=dec||inc||rem,key=el.dataset.lineDec||el.dataset.lineInc||el.dataset.lineRemove,cart=await cartJson(),item=cart.items.find(i=>i.key===key);if(!item)return;await changeLine(key,rem?0:Math.max(0,item.quantity+(inc?1:-1)))}
});

async function addForm(form){
  const btn=q('[type="submit"]',form),old=btn?.textContent;if(btn){btn.disabled=true;btn.textContent='Ajout…'}
  try{const fd=new FormData(form);const r=await fetch('/cart/add.js',{method:'POST',headers:{Accept:'application/json'},body:fd});if(!r.ok)throw new Error('Cart error');await renderCart();closeQuickBuy(false);togglePanel('#CartDrawer',true)}
  catch(err){alert('Cette combinaison n’est pas disponible. Choisissez une autre taille ou couleur.')}
  finally{if(btn){btn.disabled=false;btn.textContent=old}}
}
document.addEventListener('submit',e=>{const form=e.target.closest('[data-ajax-cart]');if(!form)return;e.preventDefault();addForm(form)});
function openCart(){renderCart().then(()=>togglePanel('#CartDrawer',true))}

function initProductForms(root=document){
  qa('[data-product-form]',root).forEach(form=>{
    if(form.dataset.initialized==='true')return;form.dataset.initialized='true';
    const select=q('select[name="id"]',form),json=q('[data-variants-json]',form);if(!json)return;
    let variants=[];try{variants=JSON.parse(json.textContent||'[]')}catch(e){return}
    qa('[data-option-input]',form).forEach(inp=>inp.addEventListener('change',()=>{
      const groups=[...new Set(qa('[data-option-input]',form).map(i=>i.name))];
      const opts=groups.map(name=>qa('[data-option-input]',form).find(i=>i.name===name&&i.checked)?.value);
      const v=variants.find(v=>v.options.every((o,i)=>o===opts[i]));
      if(v&&select){select.value=v.id;const price=q('[data-current-price]',form),compare=q('[data-compare-price]',form),btn=q('[type="submit"]',form);if(price)price.textContent=money(v.price);if(compare)compare.textContent=v.compare_at_price&&v.compare_at_price>v.price?money(v.compare_at_price):'';if(btn){btn.disabled=!v.available;btn.textContent=v.available?'Ajouter au panier':'Rupture de stock'}}
    }))
  })
}
initProductForms();

/* Product-card media thumbnails */
document.addEventListener('click',e=>{
  const thumb=e.target.closest('[data-card-thumb]');if(!thumb)return;
  e.preventDefault();e.stopPropagation();
  const card=thumb.closest('[data-product-card]');if(!card)return;
  qa('[data-card-thumb]',card).forEach(t=>t.classList.remove('is-active'));thumb.classList.add('is-active');
  const mediaLink=q('.desire-card__media-link',card),img=q('.desire-card__main-image',card),video=q('.desire-card__video',card);
  if(img){img.src=thumb.dataset.imageSrc;img.srcset=''}
  else if(video&&mediaLink){const replacement=document.createElement('img');replacement.className='desire-card__image desire-card__main-image';replacement.src=thumb.dataset.imageSrc;replacement.alt='';video.replaceWith(replacement);window.mdLuxuryMotion?.init(card)}
  else{window.mdLuxuryMotion?.init(card)}
});

/* Quick-buy drawer for multi-variant products */
async function openQuickBuy(url){
  const drawer=q('#QuickBuyDrawer'),content=q('[data-quick-buy-content]',drawer);if(!drawer||!content)return;
  content.innerHTML='<div style="padding:50px 0;text-align:center">Chargement…</div>';
  drawer.classList.add('is-open');drawer.setAttribute('aria-hidden','false');document.body.classList.add('drawer-open');
  try{const separator=url.includes('?')?'&':'?';const r=await fetch(`${url}${separator}section_id=quick-buy`);if(!r.ok)throw new Error();content.innerHTML=await r.text();initProductForms(content);window.mdLuxuryMotion?.init(content)}catch(err){content.innerHTML='<p>Impossible de charger ce produit. <a href="'+url+'">Ouvrir la fiche produit</a></p>'}
}
function closeQuickBuy(unlock=true){const drawer=q('#QuickBuyDrawer');if(!drawer)return;drawer.classList.remove('is-open');drawer.setAttribute('aria-hidden','true');if(unlock)document.body.classList.remove('drawer-open')}
document.addEventListener('click',e=>{const btn=e.target.closest('[data-quick-buy-url]');if(btn){e.preventDefault();openQuickBuy(btn.dataset.quickBuyUrl)}else if(e.target.id==='QuickBuyDrawer'){closeQuickBuy()}});

/* Autoplay only when media is visible — avoids decoding every video at once */
const videoAutoplay=document.body.dataset.videoAutoplay==='true';
if('IntersectionObserver'in window){
  const mediaObserver=new IntersectionObserver(entries=>entries.forEach(entry=>{const v=entry.target;if(entry.isIntersecting&&videoAutoplay){v.play().catch(()=>{})}else{v.pause()}}),{rootMargin:'80px 0px',threshold:.15});
  qa('.js-product-video,.js-ugc-video').forEach(v=>mediaObserver.observe(v));
  const revealObserver=new IntersectionObserver(entries=>entries.forEach(entry=>{if(entry.isIntersecting){entry.target.classList.add('is-revealed');revealObserver.unobserve(entry.target)}}),{rootMargin:'60px 0px',threshold:.08});
  qa('[data-reveal]').forEach(el=>revealObserver.observe(el));
}else{qa('[data-reveal]').forEach(el=>el.classList.add('is-revealed'))}



/* Maison Dihia 2.2 — luxury scroll motion engine */
/*
  A single requestAnimationFrame loop drives only media currently near the viewport.
  No GSAP / no scroll library: less JavaScript, fewer layout reads, better mobile stability.
*/
(function(){
  const body=document.body;
  const enabled=body?.dataset.luxuryMotion==='true';
  const reduced=window.matchMedia?.('(prefers-reduced-motion: reduce)').matches;
  if(!enabled||reduced)return;

  body.classList.add('md-luxury-motion');

  const SELECTORS=[
    '.campaign-hero__media > img',
    '.campaign-hero__media > video',
    '.hero__media > img',
    '.hero__media > video',
    '.visual-shortcut__media > img',
    '.desire-card__media img.desire-card__image',
    '.desire-card__media img.desire-card__main-image',
    '.desire-card__media video.desire-card__video',
    '.product-card__media > a > img',
    '.editorial-story__media > img',
    '.editorial-story__media > video',
    '.editorial__media > img',
    '.editorial__media > video',
    '.tile > img',
    '.ugc-card > img',
    '.ugc-card > video',
    '.ugc-shop__media > img',
    '.ugc-shop__media > video',
    '.social-tile > img',
    '.product-gallery__item > img',
    '.product-gallery__item > video',
    '.quick-buy-product__media > img'
  ].join(',');

  const active=new Set();
  let raf=0;
  let viewportH=window.innerHeight||800;
  const zoomPct=Math.max(0,Number(body.dataset.luxuryZoom||7))/100;
  const depthPx=Math.max(0,Number(body.dataset.luxuryDepth||8));
  const mobileFactor=Math.max(.35,Math.min(1,Number(body.dataset.luxuryMobileFactor||70)/100));

  function factorFor(el){
    if(el.closest('.campaign-hero__media,.hero__media'))return 1.35;
    if(el.closest('.editorial-story__media,.editorial__media'))return 1.05;
    if(el.closest('.product-gallery__item'))return .92;
    if(el.closest('.ugc-shop__media,.ugc-card'))return .82;
    if(el.closest('.visual-shortcut__media,.tile'))return .72;
    if(el.closest('.social-tile'))return .64;
    if(el.closest('.desire-card__media,.product-card__media'))return .58;
    if(el.closest('.quick-buy-product__media'))return .7;
    return .7;
  }

  function mobileAdjusted(factor){
    return window.matchMedia('(max-width: 749px)').matches ? factor*mobileFactor : factor;
  }

  function schedule(){
    if(!raf)raf=requestAnimationFrame(update);
  }

  function update(){
    raf=0;
    active.forEach(el=>{
      if(!el.isConnected){active.delete(el);return}
      const rect=el.getBoundingClientRect();
      if(rect.height<20)return;
      const center=rect.top+rect.height*.5;
      const range=viewportH*.5+rect.height*.5;
      let n=(center-viewportH*.5)/Math.max(1,range); // -1 top edge / 0 center / +1 bottom edge
      n=Math.max(-1,Math.min(1,n));
      const peak=1-Math.abs(n);
      const eased=peak*peak*(3-2*peak); // smoothstep: no abrupt acceleration around the viewport center
      const factor=mobileAdjusted(Number(el.dataset.luxuryFactor||.7));
      const amount=zoomPct*factor;
      const scale=1+amount*(.18+.82*eased);
      const y=(-n)*depthPx*factor;
      el.style.setProperty('--md-lux-scale',scale.toFixed(4));
      el.style.setProperty('--md-lux-y',`${y.toFixed(2)}px`);
    });
  }

  const io='IntersectionObserver'in window?new IntersectionObserver(entries=>{
    entries.forEach(entry=>{
      const el=entry.target;
      if(entry.isIntersecting){active.add(el);el.classList.add('is-luxury-active')}
      else{active.delete(el);el.classList.remove('is-luxury-active')}
    });
    schedule();
  },{rootMargin:'35% 0px 35% 0px',threshold:0}):null;

  function register(el){
    if(!el||el.dataset.luxuryReady==='true')return;
    el.dataset.luxuryReady='true';
    el.dataset.luxuryFactor=String(factorFor(el));
    el.classList.add('md-luxury-media');
    const frame=el.parentElement;
    // Only turn actual visual containers into clipping frames, never an anchor holding UI overlays.
    if(frame&&frame.matches('.campaign-hero__media,.hero__media,.visual-shortcut__media,.editorial-story__media,.editorial__media,.ugc-shop__media,.ugc-card,.social-tile,.product-gallery__item,.quick-buy-product__media'))frame.classList.add('md-luxury-frame');
    // Product cards have an extra anchor layer; their outer media wrapper already clips.
    el.closest('.desire-card__media,.product-card__media,.tile')?.classList.add('md-luxury-frame');
    if(io)io.observe(el);else active.add(el);
  }

  function init(root=document){
    if(root.matches?.(SELECTORS))register(root);
    root.querySelectorAll?.(SELECTORS).forEach(register);
    schedule();
  }

  window.mdLuxuryMotion={init,schedule};
  init(document);
  window.addEventListener('scroll',schedule,{passive:true});
  window.addEventListener('resize',()=>{viewportH=window.innerHeight||800;schedule()},{passive:true});
  document.addEventListener('shopify:section:load',e=>init(e.target));
  document.addEventListener('shopify:section:reorder',schedule);

  // Shopify recommendations, app blocks and theme-editor sections can inject media after first paint.
  // Observe only added nodes; no attribute watching, so this stays extremely cheap.
  if('MutationObserver'in window){
    const mo=new MutationObserver(records=>records.forEach(record=>record.addedNodes.forEach(node=>{
      if(node.nodeType===1)init(node);
    })));
    mo.observe(document.getElementById('MainContent')||document.body,{childList:true,subtree:true});
  }
})();


/* Safer than the old BMI size estimator: the theme no longer invents lingerie sizing. */
qa('[data-size-finder]').forEach(box=>{q('[data-size-calc]',box)?.addEventListener('click',()=>{const result=q('[data-size-result]',box);if(result)result.textContent='Utilisez le tableau de mesures propre à ce produit. Une recommandation automatique doit être reliée à vos mesures fournisseur avant activation.'})});

const sticky=q('[data-sticky-atc]'),mainBtn=q('[data-main-atc]');
if(sticky&&mainBtn&&'IntersectionObserver'in window){new IntersectionObserver(([entry])=>sticky.classList.toggle('is-visible',!entry.isIntersecting),{threshold:.1}).observe(mainBtn)}

qa('[data-countdown]').forEach(el=>{
  const hours=Number(el.dataset.hours||24),key='md_countdown_'+(el.dataset.key||'default');let end=Number(localStorage.getItem(key));if(!end||end<Date.now()){end=Date.now()+hours*3600000;localStorage.setItem(key,end)}
  const tick=()=>{let d=Math.max(0,end-Date.now()),h=Math.floor(d/3600000),m=Math.floor(d%3600000/60000),s=Math.floor(d%60000/1000);el.textContent=`${String(h).padStart(2,'0')} h : ${String(m).padStart(2,'0')} m : ${String(s).padStart(2,'0')} s`};tick();setInterval(tick,1000)
});
